import React, { useRef, useEffect, useImperativeHandle, forwardRef } from 'react';

// Componente confete simples em canvas
const Confetti = forwardRef(({ colors = ['#ef4444', '#f59e0b', '#10b981', '#3b82f6', '#8b5cf6'] }, ref) => {
  const canvasRef = useRef(null);
  const rafRef = useRef(null);
  const particlesRef = useRef([]);

  useImperativeHandle(ref, () => ({
    fire: (x, y, count = 80) => start(x, y, count)
  }));

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    resize();
    window.addEventListener('resize', resize);

    const render = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particlesRef.current = particlesRef.current.filter(p => {
        p.x += p.vx;
        p.y += p.vy;
        p.vy += 0.2; // gravity
        p.rotation += p.vr;
        p.life -= 1;
        if (p.life <= 0) return false;

        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.size/2, -p.size/2, p.size, p.size*0.6);
        ctx.restore();
        return true;
      });
      rafRef.current = requestAnimationFrame(render);
    };

    rafRef.current = requestAnimationFrame(render);

    return () => {
      window.removeEventListener('resize', resize);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, []);

  const start = (x = window.innerWidth/2, y = window.innerHeight/4, count = 80) => {
    const colors = ['#ef4444', '#f59e0b', '#10b981', '#3b82f6', '#8b5cf6'];
    const particles = [];
    for (let i = 0; i < count; i++) {
      const angle = Math.random() * Math.PI * 2;
      const speed = Math.random() * 6 + 2;
      particles.push({
        x: x + (Math.random()-0.5) * 80,
        y: y + (Math.random()-0.5) * 40,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed - 4,
        vr: (Math.random() - 0.5) * 0.3,
        rotation: Math.random() * Math.PI,
        size: Math.random() * 10 + 6,
        color: colors[Math.floor(Math.random() * colors.length)],
        life: Math.floor(Math.random() * 80 + 40)
      });
    }
    particlesRef.current.push(...particles);
  };

  return (
    <canvas ref={canvasRef} style={{position:'fixed', left:0, top:0, pointerEvents:'none', zIndex:9999}} />
  );
});

export default Confetti;
